
<template>
	<el-container v-loading="loadingCmp">
		<el-header v-if="!!$slots.sideBarHeader" height="50px" class="filter-aside-header layout-component-padding">
			<slot name="sideBarHeader" />
		</el-header>
		<el-main class="content">
			<slot name="sideBarContent" />
			<dms-button :disabled="false" class="dms-button" style="margin-top:20px;" type="info" icon="el-icon-close" @click="$emit('close')" />
		</el-main>
	</el-container>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
	name: 'InfoSideBar',
	props: {
		sideBarLoading: Boolean,
	},
	computed: {
		loadingCmp() {
			return this.sideBarLoading;
		},
	},
});

</script>

<style scoped>
.content{
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
}
.dms-button {
	width: 40%;
}
</style>
